import {useEffect,useState} from 'react';
import {accountRequest} from './account-api';
export default function useOwnerAccess(user){
  const [access,setAccess]=useState(null);
  useEffect(()=>{
    setAccess(null);
    if(!user?.emailVerified)return;
    const abort=new AbortController();
    accountRequest('/api/admin?section=access',{signal:abort.signal}).then(data=>{if(!abort.signal.aborted)setAccess({uid:user.uid,owner:data.owner===true});}).catch(()=>{});
    return()=>abort.abort();
  },[user?.uid,user?.emailVerified]);
  return !!user&&access?.uid===user.uid&&access.owner;
}
